var MuiClassCollection = /* @__PURE__ */ ((MuiClassCollection2) => {
  MuiClassCollection2["disabled"] = "Mui-disabled";
  MuiClassCollection2["selected"] = "Mui-selected";
  MuiClassCollection2["hovered"] = "Mui-hovered";
  MuiClassCollection2["expanded"] = "Mui-expanded";
  MuiClassCollection2["readOnly"] = "Mui-readOnly";
  return MuiClassCollection2;
})(MuiClassCollection || {});
export {
  MuiClassCollection
};
//# sourceMappingURL=mui-class-collection.es.js.map
